<div  id="tempGauge0" class="container"></div>
<div  id="tempGauge1" class="container"></div>
<div  id="tempGauge2" class="container"></div>
<div  id="tempGauge3" class="container"></div>